const navigation = {
  nav: {
    home: "Home",
    about: "Über uns",
    services: "Leistungen",
    testimonials: "Zufriedene Kunden",
    gallery: "Galerie",
    contact: "Kontakt",
  },
  servicesMenu: {
    trigger: "Leistungen",
    allServices: "Alle Leistungen anzeigen",
  },
  serviceLinks: {
    implantology: {
      name: "Implantologie",
      description: "Hochwertiger, langlebiger Zahnersatz",
    },
    endodontics: {
      name: "Endodontie",
      description: "Fortschrittliche Wurzelkanalbehandlungen",
    },
    "oral-surgery": {
      name: "Oralchirurgie",
      description: "Präzise oralchirurgische Eingriffe",
    },
    periodontology: {
      name: "Parodontologie",
      description: "Spezialisierte Zahnfleischbehandlungen und -pflege",
    },
    orthodontics: {
      name: "Kieferorthopädie",
      description: "Expertenbehandlungen für Zahnfehlstellungen",
    },
    bonding: {
      name: "Bonding (Zahnästhetik)",
      description: "Kosmetische Reparaturen mit zahnfarbenem Komposit",
    },
    prosthetics: {
      name: "Prothetik",
      description: "Maßgefertigte Brücken und Prothesen",
    },
    cariesology: {
      name: "Kariesbehandlung",
      description: "Vorbeugung und Behandlung von Karies",
    },
    "teeth-whitening": {
      name: "Zahnaufhellung (Bleaching)",
      description: "Professionelle Zahnaufhellung für ein strahlenderes Lächeln",
    },
    "dental-tourism": {
      name: "Zahntourismus",
      description: "Umfassende Zahnpflegepakete für internationale Patienten",
    },
    prices: {
      name: "Preise",
      description: "Aktuelle Preisliste nach Leistung",
    },
  },
};

export default navigation;
